import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "position", "size", "use"];
import { DragHandleIcon } from 'foundations-assets';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DragHandleContainer = styled.div.withConfig({
  displayName: "DragHandle__DragHandleContainer",
  componentId: "lk0mdy-0"
})(props => {
  return Object.assign({
    position: 'relative',
    cursor: 'grab',
    display: 'inline-block'
  }, props.$cssStyles);
});
const DragHandleIconContainer = styled.span.withConfig({
  displayName: "DragHandle__DragHandleIconContainer",
  componentId: "lk0mdy-1"
})(({
  $position,
  $use,
  theme
}) => {
  return Object.assign({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: $use === 'on-dark' ? theme.color['text-interactive-on-fill'] : theme.color['text-primary-subtle']
  }, $position === 'start' ? {
    left: '3px'
  } : {
    right: '3px'
  });
});
const mapSizeToIconSize = {
  sm: '100',
  md: '300',
  lg: '500',
  default: '300'
};
export const DragHandle = _ref => {
  let {
      children,
      position = 'start',
      size = 'md',
      use = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(DragHandleContainer, Object.assign({
    $cssStyles: cssStyles
  }, domProps, {
    children: [/*#__PURE__*/_jsx(DragHandleIconContainer, {
      $position: position,
      $use: use,
      children: /*#__PURE__*/_jsx(DragHandleIcon, {
        size: mapSizeToIconSize[size]
      })
    }), children]
  }));
};